import UtilitiesService from './UtilitiesService';
import GrIntegrationService from './GrIntegrationService';
import BillingService from './BillingService';
import PrepaidAccountService from './PrepaidAccountService';
import PropertyTaxService from './PropertyTaxService';
import WaterService from './WaterService';

const AccountLinkFactory = {};

AccountLinkFactory.getBulkLinker = ({ serviceOfferingId, }) => {
  const service = {};

  switch (serviceOfferingId) {
    case 'columbia_mo_utilities':
      service.link = (options = {}) => {
        const { customerId, bulkId, } = options;
        return WaterService.bulkLinkToAccount({ bulkId, customerId, serviceOfferingId, });
      };
      break;
    default:
      throw Error(`Unknown ID ${serviceOfferingId}`);
  }

  return service;
};

AccountLinkFactory.getBulkUnlinker = ({ serviceOfferingId, }) => {
  const service = {};

  switch (serviceOfferingId) {
    case 'columbia_mo_utilities':
      service.unlink = (options = {}) => {
        const { customerId, bulkId, } = options;
        return WaterService.bulkUnlinkFromAccount({ bulkId, customerId, serviceOfferingId, });
      };
      break;
    default:
      throw Error(`Unknown ID ${serviceOfferingId}`);
  }

  return service;
};

AccountLinkFactory.getLinker = async ({ serviceOfferingId, }) => {
  const service = {};

  switch (serviceOfferingId) {
    case 'gr_property_tax':
    case 'kck_tax':
    case 'kck_tax_personal':
    case 'beaufort_v2':
    case 'jackson_property_tax':
    case 'stl_property':
    case 'stl_water':
    case 'stl_real_estate':
      service.link = (options = {}) => {
        const soid = options.serviceOfferingId;
        const { customerId, accountId, } = options;
        return UtilitiesService.linkAccountAndCustomer(soid, accountId, customerId);
      };
      break;
    case 'gr_water':
      service.link = (options = {}) => {
        const soid = options.serviceOfferingId;
        const { customerId, accountId, } = options;
        return WaterService.linkAccountAndCustomer(soid, accountId, customerId);
      };
      break;
    case 'gr_parking':
      service.link = (options = {}) => {
        const { accountId, customerId, } = options;
        return GrIntegrationService.linkCustomerToCitation(accountId, customerId);
      };
      break;
    case 'gr_block_grants':
      service.link = (options = {}) => {
        const soid = options.serviceOfferingId;
        const { customerId, accountId, } = options;
        const accountIds = [];
        accountIds.push(accountId);
        const accountLinkRequest = { serviceOfferingId: soid, customerId, accountIds, };
        return BillingService.linkAccounts(soid, accountLinkRequest);
      };
      break;
    case 'gr_refuse':
      service.link = (options = {}) => {
        const { customerId, accountId, } = options;
        return GrIntegrationService.linkCustomerToRefuse(accountId, customerId);
      };
      break;
    case 'ppa_account':
      service.link = (options = {}) => {
        const { customerId, accountId, } = options;
        return PrepaidAccountService.linkPrepaidAccountToCustomer(accountId, customerId);
      };
      break;
    case 'beaufort':
    default: {
      const { data: { services, }, } = await PropertyTaxService.getAllPTAXServiceOfferings();
      if (services.includes(serviceOfferingId)) {
        service.link = (options = {}) => {
          const { customerId, accountId, } = options;
          return PropertyTaxService.linkToAccount({ accountId, customerId, serviceOfferingId, });
        };
      } else {
        throw Error(`Unknown ID ${serviceOfferingId}`);
      }
    }
  }

  return service;
};

AccountLinkFactory.getUnlinker = async ({ serviceOfferingId, }) => {
  const service = {};

  switch (serviceOfferingId) {
    case 'gr_property_tax':
    case 'kck_tax':
    case 'kck_tax_personal':
    case 'beaufort_v2':
    case 'jackson_property_tax':
    case 'stl_property':
    case 'stl_water':
    case 'stl_real_estate':
      service.unlink = (options = {}) => {
        const { customerId, accountId, } = options;
        return UtilitiesService.unlinkAccountAndCustomer(serviceOfferingId, accountId, customerId);
      };
      break;
    case 'gr_parking':
      service.unlink = (options = {}) => {
        const { customerId, accountId, } = options;
        return GrIntegrationService.unlinkCustomerFromCitation(accountId, customerId);
      };
      break;
    case 'gr_block_grants':
      service.unlink = (options = {}) => {
        const soid = options.serviceOfferingId;
        const { customerId, accountId, } = options;
        const accountIds = [];
        accountIds.push(accountId);
        const accountLinkRequest = { serviceOfferingId: soid, customerId, accountIds, };
        return BillingService.unlinkAccounts(soid, accountLinkRequest);
      };
      break;
    case 'gr_refuse':
      service.unlink = (options = {}) => {
        const { customerId, accountId, } = options;
        return GrIntegrationService.unlinkCustomerFromRefuse(accountId, customerId);
      };
      break;
    case 'ppa_account':
      service.unlink = (options = {}) => {
        const { customerId, accountId, } = options;
        return PrepaidAccountService.unlinkPrepaidAccountFromCustomer(accountId, customerId);
      };
      break;
    case 'beaufort':
    default: {
      const { data: { services, }, } = await PropertyTaxService.getAllPTAXServiceOfferings();
      if (!services.includes(serviceOfferingId)) {
        throw Error(`Unknown ID ${serviceOfferingId}`);
      }
      service.unlink = (options = {}) => {
        const { customerId, accountId, } = options;
        return PropertyTaxService.unlinkFromAccount({ accountId, customerId, serviceOfferingId, });
      };
    }
  }
  return service;
};

export default AccountLinkFactory;
